import Section from '@app/components/atoms/Section/Section'
import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { VOUCHER_STATUS } from '@app/constant/VoucherConstant'
import { VOUCHER_TYPE } from '@app/constant/VoucherTypeConstant'
import { toRemainingTime } from '@app/libs/format'
import { usePage } from '@inertiajs/inertia-react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

export default function CampaignVouchers() {
  const {
    props: { requestedCampaign, vouchers },
  } = usePage()
  const { t } = useTranslation()

  return (
    <Section>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container justifyContent="space-between">
            <Grid item>
              <Typography variant="h5">{t('CAMPAIGN.LIST_VOUCHER')} </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DataGrid
                enableIndexColumn
                columns={[
                  {
                    id: 'name',
                    Header: t('VOUCHER.NAME'),
                    accessor: 'name',
                    type: 'string',
                  },
                  {
                    id: 'merchant_name',
                    Header: t('VOUCHER.MERCHANT_NAME'),
                    accessor: 'merchant_name',
                    type: 'string',
                    autoHide: true,
                  },
                  {
                    id: 'price',
                    Header: t('VOUCHER.PRICE'),
                    accessor: 'price',
                    type: 'number',
                    autoHide: true,
                    disableFilters: true,
                  },
                  {
                    id: 'codes_count',
                    Header: t('VOUCHER.TOTAL_CODES'),
                    accessor: 'codes_count',
                    type: 'number',
                    autoHide: true,
                  },
                  {
                    id: 'expired_date',
                    Header: t('VOUCHER.EXPIRED'),
                    accessor: 'expired_date',
                    type: 'dateTime',
                    disableFilters: true,
                  },
                  {
                    id: 'remain_time',
                    Header: t('VOUCHER.REMAIN_TIME'),
                    accessor: ({ expired_date }) => ({ expired_date }),
                    type: 'dateTime',
                    disableFilters: true,
                    disableSortBy: true,
                    Cell: ({ row }) => <>{toRemainingTime(new Date(), row.original.expired_date)}</>,
                  },

                  {
                    id: 'type',
                    Header: t('VOUCHER.VOUCHER_TYPE'),
                    accessor: ({ type }) => t(`CODES.${type.toUpperCase()}`),
                    type: 'singleSelect',
                    typeCategories: 'Type',
                    options: [
                      { value: VOUCHER_TYPE.STANDARD, name: t('VOUCHERS.STANDARD') },
                      { value: VOUCHER_TYPE.PREMIUM, name: t('VOUCHERS.PREMIUM') },
                    ],
                  },
                  {
                    id: 'status',
                    Header: t('VOUCHER.STATUS'),
                    accessor: ({ status }) => t(`CODES.${status.toUpperCase()}`),
                    type: 'singleSelect',
                    options: [
                      { value: VOUCHER_STATUS.ACTIVE, name: t('VOUCHERS.ACTIVE') },
                      { value: VOUCHER_STATUS.IN_ACTIVE, name: t('VOUCHERS.INACTIVE') },
                    ],
                  },
                ]}
                data={vouchers}
                params={{ id: requestedCampaign.id }}
                queries={{ id: requestedCampaign.id }}
                routeName="admin.campaigns.requested.show"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Section>
  )
}
